function Features() {
  return (
    <section
      id="features"
      className="w-full h-fit flex flex-col justify-center items-center gap-10 lg:gap-12 p-8 px-12 lg:px-16"
    >
      <h1 className="text-center text-2xl font-bold">Features</h1>

      <div className="flex justify-center items-center gap-24">
        <div className="w-[23vw] hidden md:hidden lg:block">
          <img
            className="hidden lg:block"
            src="https://res.cloudinary.com/dcpgwly0i/image/upload/v1750782597/feature-1_ganr2d.png"
            alt="feature-1"
          />
        </div>
        <div className="min-w-[30vw] flex flex-col justify-center items-start">
          <h2 className="font-semibold text-lg">Smart Intake Flow</h2>
          <ul className="list-disc p-3">
            <li className="p-3 border-b border-gray-300">
              Conversational, step-by-step form
            </li>
            <li className="p-3 border-b border-gray-300">
              Location selection via map or pin
            </li>
            <li className="p-3 border-b border-gray-300">
              “Must-have” vs. “Nice-to-have” inputs
            </li>
            <li className="p-3 border-b border-gray-300">
              Capture detailed, usable property requirements effortlessly
            </li>
          </ul>
        </div>
      </div>

      <div className="flex justify-center items-center gap-24">
        <div className="min-w-[30vw] flex flex-col justify-center items-start">
          <h2 className="font-semibold text-lg">Relevancy-Based Lead Queue</h2>
          <ul className="list-disc p-3">
            <li className="p-3 border-b border-gray-300">
              Matches based on property-fit
            </li>
            <li className="p-3 border-b border-gray-300">
              Prioritizes high-conversion leads
            </li>
            <li className="p-3 border-b border-gray-300">
              Tracks broker responsiveness for each forwarded lead
            </li>
            <li className="p-3 border-b border-gray-300">
              Confidence score for each match
            </li>
          </ul>
        </div>
        <div className="w-[23vw] hidden md:hidden lg:block">
          <img
            className="hidden lg:block"
            src="https://res.cloudinary.com/dcpgwly0i/image/upload/v1750783646/feature-2_uch7hr.png"
            alt="feature-2"
          />
        </div>
      </div>

      <div className="flex justify-center items-center gap-24">
        <div className="w-[23vw] hidden md:hidden lg:block">
          <img
            className="hidden lg:block"
            src="https://res.cloudinary.com/dcpgwly0i/image/upload/v1750783648/feature-3_jvcd56.png"
            alt="feature-3"
          />
        </div>
        <div className="min-w-[30vw] flex flex-col justify-center items-start">
          <h2 className="font-semibold text-lg">Broker Dashboard</h2>
          <ul className="list-disc p-3">
            <li className="p-3 border-b border-gray-300">
              Snapshot cards for each buyer
            </li>
            <li className="p-3 border-b border-gray-300">
              One-click call, WhatsApp, or message
            </li>
            <li className="p-3 border-b border-gray-300">
              Auto-grouping by buyer demand type, budget, size
            </li>
            <li className="p-3 border-b border-gray-300">
              Learn-as-you-go lead rejection filter
            </li>
          </ul>
        </div>
      </div>

      <div className="flex justify-center items-center gap-24">
        <div className="min-w-[30vw] flex flex-col justify-center items-start">
          <h2 className="font-semibold text-lg">Lead Quality Feedback Loop</h2>
          <ul className="list-disc p-3">
            <li className="p-3 border-b border-gray-300">
              Broker success score
            </li>
            <li className="p-3 border-b border-gray-300">
              Buyer confirmation on success and rejection
            </li>
            <li className="p-3 border-b border-gray-300">
              Keeps the platform clean, informative, and trustworthy
            </li>
            <li className="p-3 border-b border-gray-300">
              Lead flagging (TBA)
            </li>
          </ul>
        </div>
        <div className="w-[23vw] hidden md:hidden lg:block">
          <img
            className="hidden lg:block"
            src="https://res.cloudinary.com/dcpgwly0i/image/upload/v1750783649/feature-4_ojiidz.png"
            alt="feature-4"
          />
        </div>
      </div>
    </section>
  );
}

export default Features;
